
export const handleError = (err: Error | unknown) => {
  if (window.location.href.indexOf('localhost') > -1) {
    console.log('[ERROR]', err);
  } else {
    console.log('[ERROR]', err);
  }
};

export const handleErrorMessage = (msg: string) => {
  if (window.location.href.indexOf('localhost') > -1) {
    console.log('[ERROR]', msg);
  } else {
    console.log('[ERROR]', msg);
  }
};
